import { clearSessionStorage } from "services/sessionStorage";
import { cancelLogoutWhenTokenExp } from "services/logoutTokenExp";

/**
 * Where an expired session lands.
 *
 * Note the explicit /auth/login: redirecting to "/" loses the query string, because
 * the unauthenticated tree ends in <Redirect from="*" to="/auth/login" /> and
 * react-router's Redirect does not carry search params over. The login screen would
 * then have no way to tell the user why they are looking at it.
 */
export const EXPIRED_SESSION_URL = "/auth/login?session=expired";

/** Clear the session and send the user to the login screen with a reason. */
export const endSession = () => {
  cancelLogoutWhenTokenExp();
  clearSessionStorage();
  window.location.href = EXPIRED_SESSION_URL;
};

export default endSession;
